import PropTypes from 'prop-types'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import logger from '../../helpers/logger'
import { displayReferenceUri, editableState } from '../../helpers/index'

import './InputsDialog.scss'
import { InputList } from './InputList'
import { EditorDialogBase } from '../EditorDialog/EditorDialogBase'

const INPUT_HEIGHT = 50

class InputsDialog extends EditorDialogBase {
  constructor(props) {
    super(props)
    //logger.info("InputsDialog::constructor", this.state);
  }

  getObjectType() {
    return 'inputs'
  }

  /**
   * Returns list of adjustments of height based on object elements.
   * Name - is a name of parameter to use,
   * Value - adjustment for element.
   */
  getElementsHeight() {
    // We have lines of settings on settings array
    return { __line: INPUT_HEIGHT }
  }

  getIconHtml() {
    return <div className="EditorDialogItem__buttonImg InputsDialog__icon"></div>
  }

  saveInputs = (inputs, closeDialog, onSent) => {
    if (onSent) onSent(closeDialog)
    //logger.info("InputsDialog:saveRules", inputs);

    this.Change(inputs)
  }

  renderEditor = (editState) => {
    //logger.info("InputsDialog:renderEditor", this.state);
    return (
      <div className="InputsDialog" onClick={() => this.onCheckDialogHeight('.InputsDialog')}>
        <InputList
          appState={this.props.appState}
          actions={this.props.actions}
          isVisible
          isEditable={editState >= editableState.EDITABLE ? editState : editableState.BROWSABLE}
          majorObject={this.props.majorObject}
          type={'input'}
          items={this.state.inputs}
          activity={this.props.activity}
          activities={this.props.activities}
          datasets={this.props.datasets}
          interfaces={this.props.interfaces}
          onEditableChange={this.onEditableChange}
          onSave={this.saveInputs}
        />
      </div>
    )
  }

  /**
   * Render view of component when window is closed
   * @returns {*}
   */
  renderItem(s, i) {
    // render one rule.
    return (
      <div className="EditorDialogItem row" key={i}>
        <div className="EditorDialogItem__name col">{s.identity.name + ': '}</div>
        <div className="EditorDialogItem__value col">
          {s.component ? displayReferenceUri(s.component.reference, s.component.subscription) : ''}
        </div>
      </div>
    )
  }
}

InputsDialog.propTypes = {}

//export default InputDialog;

function mapStateToProps(state) {
  return {
    actions: state.actions,
    appState: state.appState
  }
}

export default connect(mapStateToProps, null)(InputsDialog)
